// extracted by mini-css-extract-plugin
export default {"container":"tJzc5q","content":"PkNcIc","text":"IS1UD9","button":"gSlca9"};